export const site = {
  title: 'Retail & CPG AI Demo Hub',
  description: 'Explore real-world AI demos for retailers and CPG brands across merchandising, marketing, operations, and supply chain. Built by West Loop Strategy, in collaboration with AWS.',
  // Empty means show all configured dashboards. Otherwise use exact folder names.
  dashboardFolders: [],
  contact: {
    enabled: true,
    title: 'What could this look like for your business?',
    description: 'Talk with West Loop Strategy about bringing AI-powered experiences to your team.',
    buttonLabel: 'Talk to our team',
    email: 'info@westloop.io',
    subject: 'Retail analytics and AI demo',
    // Company LinkedIn page, shown as a button in the footer. Leave empty to hide it.
    linkedin: 'https://www.linkedin.com/company/westloopstrategy/',
  },
  event: {
    enabled: false,
    title: 'Meet AWS at Shoptalk!',
    description: 'Find us at booth #F80',
    logo: '/logos/ShopTalk-logo-3.png',
    logoAlt: 'ShopTalk',
  },
  // Homepage-only CTA (see QuickTryCard) that sends visitors to AWS's own
  // sign-up flow for the Amazon Quick Suite free tier -- added for
  // ShopTalk, where the booth's site QR code sits next to a "scan to
  // access your free Quick starter kit" note, so this page needs to be able
  // to actually get someone signed up, not just describe the product.
  quickTry: {
    enabled: true,
    title: 'Your partner from first agent to full rollout',
    description: 'Workshops, pilots, production and an embedded AI team, all backed by AWS.',
    buttonLabel: 'See how it works',
    url: 'https://quick.westloop.io',
  },
};
